import React, { useState, useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'

import {useSelector} from 'react-redux'
import {ServerConfig} from 'config'
import axios from 'axios'
import { hasPermission } from 'utils/hasPermission';

// nodejs library to set properties for components
import PropTypes from 'prop-types'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'
import { ListGroup, ListGroupItem } from 'reactstrap';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import Box from "@material-ui/core/Box";

// components
import _, { get } from 'lodash'

import Page from 'components/Page/Page'

import Labels from './Labels.js'
import DetectedUnknowns from './DetectedUnknowns.js'

const useStyles = makeStyles((theme) => ({ }))

const AIPage = (props) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if(!auth.access_token){
    return <Redirect to="/login" />
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  const isAdmin = hasPermission(auth.permissions, ['Admin', 'admin']);

  if (!isAdmin) {
    // You can also render a "no permission" message instead of redirect
    return <Redirect to="/" />;
  }

  return (
    <Page title="AI">
        <Container maxWidth={false}>

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Labels" />
            <Tab label="Unknowns" />
          </Tabs>
        </AppBar>
        
        <TabPanel value={value} index={0}>
          <Labels />
        </TabPanel>

        <TabPanel value={value} index={1}>
          <DetectedUnknowns />
        </TabPanel>

        </Container>
    </Page>
  )
}

export default AIPage

AIPage.propTypes = {
  children: PropTypes.node
}
